// @flow

import React, { Component } from 'react';
import { BrowserRouter, Link, NavLink } from 'react-router-dom';

import s from './ContactForm.scss';


export default class ContactForm extends React.Component {
  constructor(props) {
    super(props);

    this.form = {};

    this.state = {
      validate: {
        inputName: true,
        inputPhone: true,
        inputEmail: true,
        inputTexarea: true,
        inputCheckbox: true,

      },
      wasSent: false
    }
  }

  validateEmail(email) {
      var re = /\S+@\S+\.\S+/;
      return re.test(email);
  }

  validateInput(value) {
      return value.length > 0;
  }

  focusOnFirst(e) {
    e.preventDefault();
    this.form.inputName.focus();
  }



  sendForm(e) {
    e.preventDefault();

    if (!this.state.wasSent) {
      var validate = {
        inputName: true,
        inputPhone: true,
        inputEmail: true,
        inputTexarea: true,
        inputCheckbox: true,
      };

      var valid = true;

      for (var property in this.form) {
          if (this.form.hasOwnProperty(property)) {
              var element = this.form[property];

              if (element.type == 'email') {
                var v = this.validateEmail(element.value);
                if (!v) valid = false;
                validate[property] = v;
              } else if (element.type == 'checkbox') {
                var v = element.checked;
                if (property != v) {
                  if (!v) valid = false;
                  validate[property] = v;
                }
              } else {
                var v = this.validateInput(element.value);
                if (!v) valid = false;
                validate[property] = v;
              }
          }
      }

      this.setState({
        validate
      });

      if (valid) {
        let shortForm = {
          inputName: this.form.inputName.value,
          inputPhone: this.form.inputPhone.value,
          inputEmail: this.form.inputEmail.value,
          inputTexarea: this.form.inputTexarea.value,
          inputCheckbox: this.form.inputCheckbox.checked,
        };

        var xhr = new window.XMLHttpRequest();
        xhr.open("POST", "/contact-form-data", true);
        xhr.setRequestHeader('Content-Type', 'application/json');
        xhr.send(JSON.stringify(shortForm));
        xhr.onload = () => {
          this.setState({
            wasSent: true
          });

          for (var property in this.form) {
              if (this.form.hasOwnProperty(property)) {
                  this.form[property].value = '';
              }
          }
          // console.log('Formularz został wysłany.', shortForm);
        }
      }else {
        // console.log('didnt send')
      }
    } 
  }

  render() {
    return (
        <div>
          <form method="post" onSubmit={this.sendForm.bind(this)}>

            <div className="row contact-inputs">
              <div className="col-12 ">
                <input disabled={this.state.wasSent ? 'disabled' : ''} className={this.state.validate.inputName ? '' : 'error'} ref={(input) => { this.form.inputName = input; }} type="text" name="name" placeholder="Imię i Nazwisko" />
              </div>
           
              <div className="col-12 ">
                <input disabled={this.state.wasSent ? 'disabled' : ''} className={this.state.validate.inputEmail ? '' : 'error'} ref={(input) => { this.form.inputEmail = input; }} type="email" placeholder={"E-mail"} />
              </div>
              <div className="col-12 ">
                <input disabled={this.state.wasSent ? 'disabled' : ''} className={this.state.validate.inputPhone ? '' : 'error'} ref={(input) => { this.form.inputPhone = input; }} type="text" placeholder={"Telefon"} />
              </div>


              <div className="col-12">
                <textarea className='form-textarea' disabled={this.state.wasSent ? 'disabled' : ''} className={this.state.validate.inputTexarea ? '' : 'error'} ref={(input) => { this.form.inputTexarea = input; }} name="message" placeholder="Wiadomość" defaultValue={""} />
              </div>


              <div className="col-12">
                <input disabled={this.state.wasSent ? 'disabled' : ''} className={this.state.validate.inputCheckbox ? '' : 'error'} ref={(input) => { this.form.inputCheckbox = input; }} id="cb" type="checkbox" />
                <label htmlFor="cb">
                Wyrażam zgodę na przetwarzanie moich danych osobowych podanych w formularzu w celu umożliwienia kontaktu przez Selena S.A. z siedzibą we Wrocławiu. Przeczytałem <a href='http://www.tytan.pl/pl/polityka-prywatnosci/' target='_blank'>politykę prywatności </a>
                oraz <a href='http://www.tytan.pl/pl/informacje-prawne/' target='_blank'> informacje prawne</a>.
                </label>
              </div>

            </div>
            {(typeof this.props.inPopup !== undefined && this.props.inPopup) ? (
              <div className='pop-up__footer contact-form'>
                <a onClick={this.props.showContact} className='pop-up-button--apartment show-more'>Cofnij</a>
                <button className="pup-up-button--question ">Wyślij formularz</button>
              </div>
            ) : (
              <button className="form-button button-basic">Wyślij</button>
            )}
          </form>

        {this.state.wasSent ? (
          <h4 className="form-sent-info text-basic">Formularz został wysłany.</h4>
        ) : ''}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/ContactForm/ContactForm.js